// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kZqSLOk_8KUb6IeonUQ0{background:var(--background-neutral-default);border-radius:6px;flex-direction:column;gap:12px;padding:12px;display:flex}.kZqSLOk_8KUb6IeonUQ0 .OAAqvHyYuC0cnhOJs5m6{color:var(--content-primary-secondary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `kZqSLOk_8KUb6IeonUQ0`,
	"name": `OAAqvHyYuC0cnhOJs5m6`
};
export default ___CSS_LOADER_EXPORT___;
